import React, { useEffect, useState } from "react";
import { Card, Col, Descriptions, Row, Tag, Image, Divider } from "antd";
import { API_METHODS, BLANK_VALUE } from "../../constants";
import useApi from "../../hooks/useApi";
import { useLocation } from "react-router-dom";
import TableComponent from "../common/table/TableComponent";

function DetailedResult() {
  const innerTableColumns = [
    {
      title: "Section Name",
      dataIndex: "section_name",
    },
    {
      title: "Total Question",
      dataIndex: "total_question",
    },
    {
      title: "Total Marks",
      dataIndex: "total_marks",
    },
    {
      title: "Total Attempted",
      dataIndex: "total_attempted",
    },
    {
      title: "Correct Question",
      dataIndex: "correct_questions",
    },
    {
      title: "Marks Obtained",
      dataIndex: "marks_obtained",
    },
  ];
  const location = useLocation();
  const [getDetailedResultResponse, getDetailedResultRequest] = useApi(
    "/admin/student/get-result",
    null,
    API_METHODS.GET
  );

  const [getQuestionDetailsResponse, getQuestionDetailsRequest] = useApi(
    "/admin/student/get-question-details",
    null,
    API_METHODS.GET
  );

  const [result, setResult] = useState([]);
  const [items, setItems] = useState();
  const [innerTableData, setinnerTableData] = useState([]);
  const [questionDetails, setQuestionDetails] = useState(null);

  useEffect(() => {
    getDetailedResultRequest(
      null,
      API_METHODS.GET,
      `/admin/student/get-result?student_id=${location.state.student_id}&&test_id=${location.state.test_id}&&test_session_id=${location.state.test_session_id}`
    );
    getQuestionDetailsRequest(
      null,
      API_METHODS.GET,
      `/admin/student/get-question-details?student_id=${location.state.student_id}&&test_id=${location.state.test_id}&&test_session_id=${location.state.test_session_id}`
    );
  }, []);

  useEffect(() => {
    const data =
      getDetailedResultResponse.data !== BLANK_VALUE
        ? getDetailedResultResponse.data
        : [];
    setResult(data);
    if (data) {
      let items = [
        {
          key: "1",
          label: "Test Type",
          children: data.test_type,
        },
        {
          key: "2",
          label: "Total Question",
          children: data.total_questions,
        },
        {
          key: "3",
          label: "Total Marks",
          children: data.total_marks,
        },
        {
          key: "4",
          label: "Total Attempted",
          children: data.total_attempted,
        },
        {
          key: "5",
          label: "Correct Questions",
          children: data.correct_questions,
        },
        {
          key: "6",
          label: "Marks Obtained",
          children: data.marks_obtained,
        },
      ];
      setItems(items);
      if (data.test_type == 3) {
        setinnerTableData(data.sectionwise_result);
      }
    }
  }, [getDetailedResultResponse]);

  useEffect(() => {
    const data =
      getQuestionDetailsResponse.data !== BLANK_VALUE
        ? getQuestionDetailsResponse.data
        : null;
    setQuestionDetails(data);
  }, [getQuestionDetailsResponse]);

  const renderOption = (option) => {
    let color = null;
    let tag = null;
    if (option.is_correct_option && option.is_selected_option) {
      color = "#f6ffed";
      tag = <Tag color="success">Correct - Your Answer</Tag>;
    } else if (option.is_correct_option) {
      color = "#f6ffed";
      tag = <Tag color="success">Correct Answer</Tag>;
    } else if (option.is_selected_option) {
      color = "#fff1f0";
      tag = <Tag color="error">Your Answer</Tag>;
    }
    return (
      <div
        key={option.id}
        style={{
          padding: 8,
          marginBottom: 6,
          borderRadius: 4,
          background: color || "#fafafa",
          border: "1px solid #d9d9d9",
        }}
      >
        <b>{option.option_label}.</b> {option.option_text}
        {option.is_image_available && (
          <div style={{ marginTop: 4 }}>
            <Image src={option.image} width={120} />
          </div>
        )}
        {tag && <div style={{ marginTop: 4 }}>{tag}</div>}
      </div>
    );
  };

  const renderQuestion = (question) => (
    <div key={question.id} style={{ marginBottom: 20 }}>
      <p>
        <b>
          Q{question.question_number}. {question.question_text}
        </b>{" "}
        {!question.is_attempted && <Tag color="default">Not Attempted</Tag>}
      </p>
      {question.is_image_available && (
        <Image src={question.image} width={200} style={{ marginBottom: 8 }} />
      )}
      {question.options.map(renderOption)}
    </div>
  );

  return (
    <Card title={"Result"}>
      <Row gutter={[16, 16]}>
        <Col span={6}>
          <b>Test Name : {location.state.test_name}</b>
        </Col>
        <Col span={6}>
          <b>Mock Test Number : {location.state.mock_test_number}</b>
        </Col>
      </Row>
      {result && (
        <Descriptions
          bordered
          items={items}
          style={{ margin: 5, paddingTop: 20 }}
        />
      )}
      {result && result.test_type == 3 && innerTableData.length > 0 && (
        <TableComponent
          columns={innerTableColumns}
          tableData={innerTableData}
        />
      )}

      {questionDetails && (
        <>
          <Divider>Question Wise Details</Divider>
          {questionDetails.test_type == 3
            ? questionDetails.sections?.map((section) => (
                <div key={section.name} style={{ marginBottom: 24 }}>
                  <h3>{section.name}</h3>
                  {section.questions.map(renderQuestion)}
                </div>
              ))
            : questionDetails.questions?.map(renderQuestion)}
        </>
      )}
    </Card>
  );
}

export default DetailedResult;
